<app-license-banner></app-license-banner>
<div id="login">
    <div class="login flex-col">
        <div class="grow-2"></div>
        <div class="login-box flex-row">
            <div class="grow-4"></div>
            <div class="card-login">
                <div class="login-header">
                    <img
                        appImageSelector
                        alt="mt-image"
                        imageType="logo-login"
                        imageKey="logo-login"
                    />
                    <div class="version">
                        <app-version></app-version>
                    </div>
                </div>

                <div class="card-body login-body">
                    <div class="login-title">
                        {{ "init_sesion" | lang | uppercase }}
                    </div>
                    <form [formGroup]="loginForm" (ngSubmit)="submit()">
                        <div class="form-group">
                            <label class="control-label text-capitalize">{{
                                "user" | lang
                            }}</label>
                            <div class="col-md-12">
                                <input
                                    (keydown)="
                                        validateNoStartOrEndWithDot($event)
                                    "
                                    (keydown.enter)="submit()"
                                    maxlength="50"
                                    type="text"
                                    [ngClass]="{ 'input-error': errorMessage }"
                                    placeholder="{{ 'enter_user' | lang }}"
                                    formControlName="username"
                                    class="form-control input-md text-lowercase"
                                    (focus)="errorMessage = ''"
                                    data-cy="input-username"
                                    autofocus
                                />
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label text-capitalize">{{
                                "password" | lang
                            }}</label>
                            <div class="col-md-12">
                                <input
                                    appCapsLock
                                    #password
                                    (keydown.enter)="submit()"
                                    maxlength="20"
                                    type="password"
                                    (capsLock)="capsOn = $event"
                                    placeholder="{{ 'enter_password' | lang }}"
                                    formControlName="password"
                                    class="form-control input-md"
                                    [ngClass]="{
                                        'input-error': errorMessage
                                    }"
                                    (focus)="
                                        showIconActive = true; errorMessage = ''
                                    "
                                    (blur)="checkPasswordFocus(password)"
                                    data-cy="input-password"
                                    (keydown)="validateChars($event)"
                                    (keyup)="errorMessage = ''"
                                />

                                <img
                                    class="show-password"
                                    appImageSelector
                                    alt="mt-attention"
                                    [imageType]="
                                        showIconActive
                                            ? 'icon-active'
                                            : 'icon-inactive'
                                    "
                                    [imageKey]="
                                        password.type === 'password'
                                            ? errorMessage
                                                ? 'open-eye-black'
                                                : 'open-eye'
                                            : 'close-eye'
                                    "
                                    (click)="
                                        togglePasswordVisibility(password);
                                        checkPasswordFocus(password, true)
                                    "
                                />
                            </div>
                        </div>

                        <div
                            class="login-error justify-content-start"
                            *ngIf="errorMessage"
                        >
                            <img
                                appImageSelector
                                alt="mt-attention"
                                width="15"
                                imageType="icon"
                                imageKey="attention"
                            />
                            <span
                                class="error-message"
                                *ngFor="let message of errorMessage"
                                >{{ message }} <br
                            /></span>
                        </div>

                        <div
                            class="caps-on flex justify-content-start"
                            *ngIf="capsOn && showIconActive"
                        >
                            <img
                                class="m-1"
                                appImageSelector
                                alt="mt-attention"
                                width="15"
                                imageType="icon"
                                imageKey="attention"
                            />
                            <span class="mx-2"
                                >{{ "caps-lock" | lang }} <br
                            /></span>
                        </div>

                        <div class="form-group button-group">
                            <app-button-state
                                data-cy="button-submit"
                                [disabled]="!loginForm.valid"
                                class="button action"
                                [text]="'login'"
                                [state]="state"
                                (clickHandler)="submit()"
                            ></app-button-state>
                        </div>
                    </form>
                    <div class="footer flex justify-content-center">
                        <app-default-footer
                            [isLogin]="true"
                        ></app-default-footer>
                    </div>
                </div>
            </div>
            <div class="grow-4"></div>
        </div>

        <div class="grow-2"></div>
    </div>
</div>
